import { multi, OTHER, option, type UsWorksheetDefinition } from "../us-fields";

export const US_SBO: UsWorksheetDefinition = {
  examType: "us_sbo",
  version: 1,
  indications: [
    option("abdominal_pain", "Abdominal pain"),
    option("abdominal_distention", "Abdominal distention"),
    option("constipation", "Constipation or obstipation"),
    option("vomiting", "Vomiting"),
  ],
  otherIndication: true,
  sections: [
    {
      id: "sbo_findings",
      label: "Findings",
      role: "findings",
      technicallyLimited: true,
      fields: [
        multi("sbo.findings", "Findings", [
          option("no_dilated_loops", "No dilated small bowel loops"),
          option(
            "three_or_more_dilated_loops",
            "3 or more dilated bowel loops (>2.5 cm)",
          ),
          option(
            "one_or_two_dilated_loops",
            "1-2 dilated small bowel loops (>2.5 cm)",
          ),
          option("to_and_fro_peristalsis", "To and fro peristalsis"),
          option("free_fluid", "Free fluid adjacent to bowel"),
          option("thickened_wall", "Thickened bowel wall"),
          OTHER,
        ]),
      ],
    },
    {
      id: "sbo_impression",
      label: "Impression",
      role: "impression",
      fields: [
        multi("sbo.impression", "Impression", [
          option("no_sbo", "No small bowel obstruction"),
          option("sbo", "Small bowel obstruction"),
          option("indeterminate", "indeterminate"),
          OTHER,
        ]),
      ],
    },
  ],
  normalImpressions: [{ sectionId: "sbo_impression", value: "no_sbo" }],
  billing: {
    codes: [
      { cpt: "76705", label: "Abdominal Ultrasound, limited", preTick: true },
    ],
  },
};
